import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';

const FinalCTA = () => {
  return (
    <section className="final-cta">
      <div className="container-custom">
        <div className="final-cta-content fade-in">
          <h2 className="headline-secondary" style={{ fontSize: '2rem', marginBottom: '1rem' }}>
            Jetzt kostenlos beraten lassen
          </h2>
          <p style={{ fontSize: '1rem', marginBottom: '1.5rem', opacity: 0.9 }}>
            Schreiben Sie uns per WhatsApp oder füllen Sie das Formular aus – wir finden gemeinsam die passende Lösung.
          </p>

          <a 
            href="https://wa.me/4921288137120?text=Ich%20bin%20sehr%20an%20einem%20Angebot%20interessiert%20STERBEGELD-EXPERTEN"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-light"
            style={{ 
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <MessageCircle size={18} />
            WhatsApp
          </a>
        </div>
      </div>

      <footer className="footer">
        <div className="container-custom">
          <div className="footer-content">
            <p>&copy; {new Date().getFullYear()} Sterbegeld Experten. Alle Rechte vorbehalten.</p>
            <div className="footer-links">
              <a href="/impressum">Impressum</a>
              <span style={{ margin: '0 0.5rem', color: '#999' }}>|</span>
              <a href="/datenschutz">Datenschutz</a>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default FinalCTA;
